export default "__VITE_ASSET__de3ce2f1__"